module.exports = __webpack_public_path__ + "img/detail0.cfb55cc5.jpg";